/* tslint:disable */
/* eslint-disable */
/**
 * OMS API
 * The documentation for the Order Management System (OMS) backend API.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// @ts-ignore
import { exists, mapValues } from '../runtime';
// @ts-ignore
import type { BillingAddress } from './BillingAddress';
// @ts-ignore
import {
// @ts-ignore
    BillingAddressFromJSON,
// @ts-ignore
    BillingAddressFromJSONTyped,
// @ts-ignore
    BillingAddressToJSON,
} from './BillingAddress';

/**
 * Billing contact and legal details used for invoicing and tax.
 * @export
 * @interface BillingDetails
 */
export interface BillingDetails {
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    companyName: string;
    /**
     * 
     * @type {string}
     * @memberof BillingDetails
     */
    billingEmail: string;
    /**
     * Tax or VAT identification number, if applicable.
     * @type {string}
     * @memberof BillingDetails
     */
    taxId?: string | null;
    /**
     * 
     * @type {BillingAddress}
     * @memberof BillingDetails
     */
    address?: BillingAddress;
}

/**
 * Check if a given object implements the BillingDetails interface.
 */
// @ts-ignore
export function instanceOfBillingDetails(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "companyName" in value;
    isInstance = isInstance && "billingEmail" in value;

    return isInstance;
}

// @ts-ignore
export function BillingDetailsFromJSON(json: any): BillingDetails {
    return BillingDetailsFromJSONTyped(json, false);
}

// @ts-ignore
export function BillingDetailsFromJSONTyped(json: any, ignoreDiscriminator: boolean): BillingDetails {
// @ts-ignore
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'companyName': json['company_name'],
        'billingEmail': json['billing_email'],
        'taxId': !exists(json, 'tax_id') ? undefined : json['tax_id'],
        'address': !exists(json, 'address') ? undefined : BillingAddressFromJSON(json['address']),
    };
}

// @ts-ignore
export function BillingDetailsToJSON(value?: BillingDetails | null): any {
// @ts-ignore
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'company_name': value.companyName,
        'billing_email': value.billingEmail,
        'tax_id': value.taxId,
        'address': BillingAddressToJSON(value.address),
    };
}

